var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sku-test-trek__cta mb-1 mt-1"},[_c('trek-link',{class:_vm.cssClass,attrs:{"block":"","button":"","secondary":"","href":_vm.url,"target":_vm.target}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.linkName)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }